const domainURL = $('body').data('domain');

function uploadVideoThumbnail() {
  var formData = new FormData();
  var def = $.Deferred();
  var fileContainer = document.getElementById('videoThumbnailFile');
  if (fileContainer && fileContainer.files[0] && fileContainer.files[0].type.indexOf("image") > -1) {
    formData.append("videoThumbnailFile", fileContainer.files[0]);

    $.ajax({
      url: domainURL + "/api/Videos/UploadImage",
      type: "POST",
      data: formData,
      enctype: 'multipart/form-data',
      processData: false, // tell jQuery not to process the data
      contentType: false // tell jQuery not to set contentType
    }).done(function(data) {
      def.resolve(data);
    }).fail(function(data) {
      def.reject(data);
    });
  } else {
    def.resolve();
  }

  return def;
}

export default uploadVideoThumbnail;
